
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
export const IS_MOBILE= 'IS_MOBILE';
export const SHOW_LOGIN_DIALOG = 'SHOW_LOGIN_DIALOG';
export const TPGGLE_LOGIN_DIALOG = 'TPGGLE_LOGIN_DIALOG';
export const RECEIVE_USERS = 'RECEIVE_USERS';
export const UPDATE_POINTS = 'UPDATE_POINTS';


export const RECEIVE_MEDIA = 'RECEIVE_MEDIA';

export const RECEIVE_SLIDERS = 'RECEIVE_SLIDERS';

export const RECEIVE_TRAININGS_PAGES = 'RECEIVE_TRAININGS_PAGES';

export const RECEIVE_NEWS = 'RECEIVE_NEWS';
export const PUT_NEWS_ITEM = 'PUT_NEWS_ITEM';
export const PUT_NEWS_ITEM_COMMENT = 'PUT_NEWS_ITEM_COMMENT';
export const RECEIVE_NEWS_COMMENTS = 'RECEIVE_NEWS_COMMENTS';
export const SET_ACTIVE_COMMENT = 'SET_ACTIVE_COMMENT';
export const SET_ACTIVE_ARTICLE = 'SET_ACTIVE_ARTICLE';

export const GET_ATHLETE_INFO_TEXT = 'GET_ATHLETE_INFO_TEXT';
export const GET_COACH_INFO_TEXT = 'GET_COACH_INFO_TEXT';
export const GET_DIRECTORATE = 'GET_DIRECTORATE';
export const GET_COACH_ATHLETE_MAPPING = 'GET_COACH_ATHLETE_MAPPING';
export const GET_TROPHY_LIST = 'GET_TROPHY_LIST';

export const RECEIVE_TIME_TABLES = 'RECEIVE_TIME_TABLES';
